import type { WidgetEventType } from '../types/chat.types';

class DomEventService {
  private static instance: DomEventService;

  private constructor() {}

  public static getInstance(): DomEventService {
    if (!DomEventService.instance) {
      DomEventService.instance = new DomEventService();
    }
    return DomEventService.instance;
  }

  /**
   * Emit a widget event to the parent window
   */
  public emitEvent(type: WidgetEventType, payload?: any): void {
    window.dispatchEvent(new CustomEvent(type, { detail: payload }));
    
    console.debug(`[ChatbotWidget] Event emitted: ${type}`, payload);
  }
}

export const domEventService = DomEventService.getInstance();